import {
  FETCH_QUICK_APPLY_CRITERIA_REQUEST,
  FETCH_QUICK_APPLY_CRITERIA_SUCCESS,
  FETCH_QUICK_APPLY_CRITERIA_FAILURE,
} from "./action";

const initialState = {
  error: "",
  loading: false,
  criteria: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUICK_APPLY_CRITERIA_REQUEST:
      return { ...state, loading: true };
    case FETCH_QUICK_APPLY_CRITERIA_SUCCESS:
      return { ...state, loading: false, criteria: action.payload, error: "" };
    case FETCH_QUICK_APPLY_CRITERIA_FAILURE:
      return { ...state, loading: false, criteria: null, error: action.payload };

    default:
      return state;
  }
};

export default rootReducer;
